module.exports = __webpack_public_path__ + "assets/img/2.8bf4f587.png";